import { SectionShell, Field } from "./SectionShell";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { inputCls } from "./constants";

export default function FinanceTab({ data, update }) {
  const setF = (key, value) => update({ financial: { ...data.financial, [key]: value } });
  return (
    <SectionShell eyebrow="Section 6 · 5 min" title="Financial Context + Wrap-Up">
      <div className="grid md:grid-cols-2 gap-6">
        <Field label="Hourly value of their time ($)">
          <Input type="number" data-testid="hourly-value" className={inputCls} value={data.financial?.hourly_value || 0} onChange={(e) => setF("hourly_value", parseFloat(e.target.value) || 0)} />
        </Field>
        <Field label="Current monthly software spend ($)">
          <Input type="number" data-testid="monthly-spend" className={inputCls} value={data.financial?.monthly_software_spend || 0} onChange={(e) => setF("monthly_software_spend", parseFloat(e.target.value) || 0)} />
        </Field>
        <div className="md:col-span-2">
          <Field label="Any wasted tool purchases?">
            <Textarea data-testid="wasted-purchases" className={inputCls} rows={2} value={data.financial?.wasted_purchases || ""} onChange={(e) => setF("wasted_purchases", e.target.value)} />
          </Field>
        </div>
        <Field label="Preferred walkthrough call timeline">
          <Input data-testid="walkthrough-timeline" className={inputCls} value={data.financial?.walkthrough_timeline || ""} onChange={(e) => setF("walkthrough_timeline", e.target.value)} />
        </Field>
        <Field label="Delivery method">
          <Input data-testid="delivery-method" className={inputCls} value={data.financial?.delivery_method || ""} onChange={(e) => setF("delivery_method", e.target.value)} />
        </Field>
        <div className="md:col-span-2">
          <Field label="Additional Notes">
            <Textarea data-testid="additional-notes" className={inputCls} rows={3} value={data.financial?.additional_notes || ""} onChange={(e) => setF("additional_notes", e.target.value)} />
          </Field>
        </div>
      </div>

      <div className="mt-10 pt-8 border-t border-navy/10">
        <div className="eyebrow text-gold mb-2">Revenue Depth</div>
        <p className="text-xs text-navy/60 mb-5">Required for the Data Request Checklist and Proposal Notes pricing frame.</p>
        <div className="grid md:grid-cols-3 gap-5">
          <Field label="Trailing 12-month revenue (range OK)">
            <Input data-testid="fin-revenue-t12" className={inputCls} value={data.financial?.revenue_t12 || ""}
              onChange={(e) => setF("revenue_t12", e.target.value)}
              placeholder="e.g. $800K – $1.2M" />
          </Field>
          <Field label="Gross margin or COGS">
            <Input data-testid="fin-gross-margin" className={inputCls} value={data.financial?.gross_margin || ""}
              onChange={(e) => setF("gross_margin", e.target.value)}
              placeholder="e.g. ~55% / Service-based / Unknown" />
          </Field>
          <Field label="CAC / LTV (if tracked)">
            <Input data-testid="fin-cac-ltv" className={inputCls} value={data.financial?.cac_ltv || ""}
              onChange={(e) => setF("cac_ltv", e.target.value)}
              placeholder="e.g. CAC $400 / LTV $4,500" />
          </Field>
        </div>
      </div>
    </SectionShell>
  );
}
